let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cGSfe"), load("8E4u5"), load("dhqJV")]).then(() => parcelRequire('fzbVm'));